import { Button } from '@mantine/core';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';

import { useStyles } from './UnauthorizedPage.styles';
import { AuthenticationModuleClientType } from '../../../../types';

export const UnauthorizedPage: AuthenticationModuleClientType['UnauthorizedPage'] = ({
  onCallLogoutEndpoint,
  paths
}) => {
  const { login } = paths;
  const router = useRouter();

  const loginUrl = `${login}?redirectTo=${router.query.redirectTo}`;

  const { classes } = useStyles();

  const { t } = useTranslation('external-modules');

  const handleLogOut = async () => {
    await onCallLogoutEndpoint();
    await router.push(loginUrl);
  };

  return (
    <div className={classes.container}>
      <h1>{t('authenticationGoogle.unauthorizedPage.title')}</h1>
      <Button onClick={handleLogOut}>{t('authenticationGoogle.unauthorizedPage.button')}</Button>
    </div>
  );
};
